import React from 'react';
import classNames from 'classnames';
import ABSParagraph from '../ABSParagraph';
import './index.less';

export interface IABSCommentProps {
  children: React.ReactNode|string;
  className?: string | null;
}

export default class ABSComment extends React.Component<IABSCommentProps> {
  public render() {
    const {children, className} = this.props;
    const clazz = classNames('abs-comment', className);
    return (
      <ABSParagraph className={clazz}>
        {children}
      </ABSParagraph>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSComment/index.tsx